import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener("submit", this.handleSubmit.bind(this));
    this.element.setAttribute("novalidate", "");
  }

  disconnect() {
    this.element.removeEventListener("submit", this.handleSubmit.bind(this));
  }

  handleSubmit(event) {
    if (!this.element.checkValidity()) {
      event.preventDefault();
      event.stopPropagation();

      // Add validation styles to invalid fields
      this.element.querySelectorAll(":invalid").forEach((field) => {
        field.classList.add("border-red-500", "dark:border-red-400");
        field.classList.remove(
          "border-gray-300",
          "dark:border-gray-600",
          "focus:border-primary-500",
        );
      });
    }
  }
}
